import { useCallback } from 'react';

interface SecurityViolation {
  type: string;
  details?: any;
  timestamp: number;
  userAgent: string;
  url: string;
}

export const useSecurityMonitoring = () => {
  const reportSecurityViolation = useCallback((violationType: string, details?: any) => {
    const violation: SecurityViolation = {
      type: violationType,
      details,
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      url: window.location.href
    };

    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.warn('Security Violation:', violation);
    }

    // In production, you might want to send this to a logging service
    // For now, we'll just store it locally and log it
    try {
      const violations = JSON.parse(localStorage.getItem('security_violations') || '[]');
      violations.push(violation);
      
      // Keep only the last 50 violations to prevent storage overflow
      const recentViolations = violations.slice(-50);
      localStorage.setItem('security_violations', JSON.stringify(recentViolations));
    } catch (error) {
      console.error('Failed to store security violation:', error);
    }
  }, []);

  const getStoredViolations = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem('security_violations') || '[]');
    } catch {
      return [];
    }
  }, []);

  const clearViolations = useCallback(() => {
    localStorage.removeItem('security_violations');
  }, []);

  return {
    reportSecurityViolation,
    getStoredViolations,
    clearViolations
  };
};
